import { h, render, Component } from 'preact'; // eslint-disable-line no-unused-vars

export default () => {
  Array.from(document.getElementsByTagName('SportIcon')).forEach((el) => {
    el.setAttribute('class', 'icon-wrapper');
    render((
      <svg className="icon icon__sport" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 51 51">
        <circle className="background" cx="25.5" cy="25.5" r="25.5"/>
        <path className="foreground" d="M25.5,38.53c-10.86,0-19.69-5.84-19.69-13s8.83-13,19.69-13,19.69,5.84,19.69,13S36.36,38.53,25.5,38.53Zm0-25.1c-10.34,0-18.76,5.42-18.76,12.08S15.16,37.6,25.5,37.6a28.48,28.48,0,0,0,7.06-.89c6.72-1.68,11.69-6.07,11.69-11.2,0-6.66-8.41-12.08-18.76-12.08Z"/>
        <path className="foreground" d="M37.15,34.23a12.1,12.1,0,0,1-.33-17.11l.33-.33c4,2.16,6.48,5.41,6.48,8.72S41.2,32.06,37.15,34.23Z"/>
        <path className="foreground" d="M13.86,34.23c-4-2.16-6.48-5.41-6.48-8.72s2.4-6.55,6.48-8.72a12.1,12.1,0,0,1,.33,17.11l-.33.33Z"/>
        <rect className="foreground" x="25.03" y="12.94" width="0.94" height="25.1"/>
        <path className="foreground" d="M25.5,23.81a1.71,1.71,0,1,1-1.71,1.71h0A1.71,1.71,0,0,1,25.5,23.81Z"/>
      </svg>
    ), el);
  });
};
